import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import MobileInstall from "./components/MobileInstall";
import TvInstall from "./components/TvInstall";
import Devices from "./components/Devices";
import Versions from "./components/Versions";
import Tips from "./components/Tips";
import Faq from "./components/Faq";
import Safety from "./components/Safety";
import CtaBanner from "./components/CtaBanner";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 flex flex-col">
      <Navbar />
      <main className="w-full flex-1">
        <Hero />
        <Features />
        <MobileInstall />
        <TvInstall />
        <Devices />
        <Versions />
        <Tips />
        <Faq />
        <Safety />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
}